import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import PostLogin from '../../layout/postLogin'
import UserVerification from './components/userVerification'
import UserAccess from './components/userAccess'
import UserSignup from './components/userSignup'
import { NAME_USER_MANAGEMENT } from '../../constants'
import { Wrapper } from './style'

const UserManagement = ({ page }) => {
  const [isValidUser, setValidUser] = useState(false)

  useEffect(() => {
    if (page === 'default') {
      document.title = NAME_USER_MANAGEMENT
    }
  }, [])

  return (
    <PostLogin pageTitle={NAME_USER_MANAGEMENT}>
      <Wrapper>
        {!isValidUser && <UserVerification onChange={() => setValidUser(true)} />}
        {isValidUser && <UserAccess />}
        {isValidUser && <UserSignup />}
      </Wrapper>
    </PostLogin>
  )
}

UserManagement.propTypes = {
  page: PropTypes.string
}

export default UserManagement
